import UntrackedModel from "~/models/untracked/untrackedModel.ts";
import {AppNotificationType} from "../enums/appNotificationType";
import IRepo from "~/interfaces/repo";
import Repo from "~/state/modules/repo";
import {ExportConfig} from '~/interfaces/exportInterfaces'

export default class AppNotification extends UntrackedModel {
  static repo: IRepo<AppNotification> = new Repo<AppNotification>('app_notifications', AppNotification);

  app_notification_type: AppNotificationType
  organization_id: string
  resource_id: string
  resource_type: string
  user_id: string
  author: object
  title: string
  messsage: string
  is_read: boolean;
  is_hidden: boolean
  is_saved: boolean
  file_download_data: object | null
  export_progress_data: ExportConfig

  get isMessage(): boolean {
    return this.app_notification_type === AppNotificationType.Message;
  }
}
